export interface CompanySubscriptionDto {
  type?: string;
  expend?: string;
  paymentMethos?: string;
}

export interface CompanySubscription {
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  id: string;
  companyId: string;
  version: number;
  status: string;
  priceId: string;
  amount: number;
  quantity: number;
  latestInvoiceId: string;
  latestEventCreated: string | null;
  canceledAt: string | null;
  willEndAt: string | null;
  periodStart: string | null;
  periodEnd: string | null;
}
